import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
	static targets = [ "field", "previewContainer", "tempFile"]

	connect() {
		this.restroeTempFile()
	}

	keepTempFile(event) {
		const file = event.target.files[0]

		if (file) {
      const tempId = `temp_${encodeURI(file.name)}_${file.size}`
			let input = document.getElementById(tempId)
			if (!input) input = document.createElement('input')
			input.setAttribute('id', tempId)
			input.setAttribute('type', 'file')
			input.setAttribute('hidden', 'true')

			const dataTransfer = new DataTransfer();
      dataTransfer.items.add(file);
      input.files = dataTransfer.files;
			document.querySelector('form').parentElement.appendChild(input)
			this.previewImage(file)
			this.previewVideo(file)
    }
	}

	restroeTempFile() {
		if (!this.hasFieldTarget || !this.hasTempFileTarget) return

		const input = document.getElementById(this.tempFileTarget.innerText)
		if (input) {
			const file = input.files[0]
			if (file) {
				const dataTransfer = new DataTransfer()
				dataTransfer.items.add(file)
				this.fieldTarget.files = dataTransfer.files
				this.previewImage(file)
				this.previewVideo(file)
			}
		}
	}

	previewImage(file) {
		if (!file) return
		if (!file.type.match('image.*')) return

		const reader = new FileReader()
		reader.onload = (e) => {
      const imageData = e.target.result

      this.previewContainerTarget.innerHTML = `
        <img src="${imageData}"
             class="max-w-160 max-h-90 object-contain rounded-lg"
             alt="圖片預覽" />`
    }
    reader.readAsDataURL(file)
	}

	previewVideo(file) {
		if (!file) return;
		if (!file.type.match('video.*')) return;
		
		const videoURL = URL.createObjectURL(file);
		this.previewContainerTarget.innerHTML = `
			<video src="${videoURL}" controls width="640" height="360">
				Your browser does not support the video tag.
			</video>`;
	}
}
